import { useApi } from '@/api';
import {
  ExternalLinkIcon,
  KpiCard,
  LinkButton,
  Page,
  PageSkeleton
} from '@/components';
import { Flex, Heading } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import DocumentTable from './DocumentTable';
import TransactionTable from './TransactionTable';

export default function PortfolioPage() {
  const { ilk } = useParams();
  const [data, error] = useApi({
    url: `/rwa/${ilk}/portfolio/`
  });

  if (error) {
    throw error;
  }
  if (data) {
    const link = `https://connect.sky.money/d/sky/Blocktower/BlocktowerAndromeda/`;
    return (
      <Page
        title={data.arranger_name}
        actions={
          <LinkButton to={link} target="_blank">
            <Flex gap="3xs" alignItems="center">
              See report details <ExternalLinkIcon size={16} />
            </Flex>
          </LinkButton>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Total Liability"
            data={data}
            field="liability"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: 'USD'
                }
              }
            }}
          />

          <KpiCard
            title="Total Asset Value"
            data={data}
            field="asset_value"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: 'USD'
                }
              }
            }}
          />
          <KpiCard
            title="Accrued Interest"
            data={data}
            field="accrued_interest"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: 'USD'
                }
              }
            }}
          />
        </Flex>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Total Cash Balance"
            data={data}
            field="cash_balance"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: 'USD'
                }
              }
            }}
          />

          <KpiCard
            title="Total Realised Surplus"
            data={data}
            field="surplus"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: 'USD'
                }
              }
            }}
          />
        </Flex>
        <Heading size="3">Portfolio</Heading>
        <DocumentTable ilk={ilk} />
        <Heading size="3">Events</Heading>
        <TransactionTable ilk={ilk} />
      </Page>
    );
  }
  return <PageSkeleton />;
}
